import React, { useContext } from 'react';
import { PartnerContext } from '../contexts/partner/partner-context';

export const PartnerProvider = ({ children, value }) => {
  return (
    <PartnerContext.Provider value={value}>{children}</PartnerContext.Provider>
  );
};

export const usePartner = () => {
  const context = useContext(PartnerContext);
  if (context === undefined) {
    throw new Error('usePartner must be used within a PartnerProvider');
  }
  return context;
};
